export default "/static/images/b47f6cff7a019fbbd65460f39583f4fc.dae";